<h1 class="p-4 pt-8 text-3xl font-bold">All Referrals</h1>
<div class="bg-white rounded-3xl shadow-md px-5">
  <table cdk-table [dataSource]="dataSource" fixedLayout class="w-full">
    <thead>
      <!-- Marketplace Status Column -->
      <ng-container cdkColumnDef="marketplaceStatus">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Marketplace Status</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4 text-slate-600">
          <span>{{ element.marketplaceStatus }}</span>
        </td>
      </ng-container>

      <!-- Delivered Date Column -->
      <ng-container cdkColumnDef="addDate">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Delivered</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4 text-slate-600">
          {{ isToday(element.addDate) ? "Today" : (element.addDate | date: "shortDate") }}
          <br />
          {{ element.addDate | date: "shortTime" }}
        </td>
      </ng-container>

      <!-- Delivered Date Column -->
      <ng-container cdkColumnDef="age">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Age</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4 text-slate-600">
          <div *ngIf="timeAgo(element.addDate) == 'New'" class="inline-block items-center rounded-full px-4 py-1 my-1 text-xs font-medium ring-inset bg-green-500 text-white"></div>
          <div *ngIf="timeAgo(element.addDate) != 'New'">{{ element.addDate | dateAgo }}</div>
        </td>
      </ng-container>

      <!-- Category Column -->
      <ng-container cdkColumnDef="category">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Category</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.category }}</td>
      </ng-container>

      <!-- Lines of Business Column -->
      <ng-container cdkColumnDef="linesOfBusiness">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Policy Type</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.linesOfBusiness.join(", ") }}</td>
      </ng-container>

      <!-- Industry Column -->
      <ng-container cdkColumnDef="industry">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Industry (NAICS)</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.industry }}</td>
      </ng-container>

      <!-- Employees Column -->
      <ng-container cdkColumnDef="employees">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4"># Employees</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.numberOfEmployees }}</td>
      </ng-container>

      <!-- Years in Business Column -->
      <ng-container cdkColumnDef="yearsInBusiness">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Years in Business</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.yearsInBusiness }}</td>
      </ng-container>

      <!-- Estimated Premium Column -->
      <ng-container cdkColumnDef="estimatedPremium">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Est. Premium</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.estimatedPremium }}</td>
      </ng-container>

      <!-- Location Column -->
      <ng-container cdkColumnDef="location">
        <th cdk-header-cell *cdkHeaderCellDef class="p-4">Location</th>
        <td cdk-cell *cdkCellDef="let element" class="p-4">{{ element.location }}</td>
      </ng-container>
    </thead>
    <tbody>
      <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay" class="font-medium text-left text-slate-500"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: columnsToDisplay" class="border-t hover:bg-slate-50 hover:shadow-md text-slate-600"></tr>
    </tbody>
  </table>
</div>
